interface Props {
    regEx?: string;
}

export default function init(container: HTMLElement, { regEx }: Props) {
    const passwordInput = container.querySelector('.js-password') as HTMLInputElement;
    if (passwordInput) {
        const showPasswordIcon = container.querySelector('.js-show-password');
        // if present, enable "show password" icon
        if (showPasswordIcon) {
            showPasswordIcon.addEventListener('click', function (e: Event) {
                e.preventDefault();
                if (passwordInput.type === 'password') {
                    passwordInput.type = 'text';
                } else {
                    passwordInput.type = 'password';
                }
            });
        }
        // if defined, apply regex validation
        if (regEx) {
            // if class is present, use a different element for the border color
            const passwordBorderElem = (container.querySelector('.js-password-border') as HTMLElement) ?? passwordInput;
            const passwordRegEx = new RegExp(regEx);
            passwordInput.addEventListener('keyup', function (e: Event) {
                passwordBorderElem.style.borderColor = passwordRegEx.test(passwordInput.value) ? '#489048' : '#dd1212';
            });
        }
    }
}
